import React, { useState } from 'react';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';
import { ProductEntity } from 'sl-api-connector';
import ProductCell from 'src/components/BeaconV2Components/ProductCell/ProductCell';
import { ContentAccuracyFieldName } from './ContentAccuracyPage';
import useRetailSalesSortedSkus from 'src/serverProxy/useRetailSalesSortedSkus';
import { CONTENT_TABLE_HEADER_DISPLAY_NAMES } from 'src/components/BeaconV2Components/ExperimentalLayout/Content/constants';

/**
 * Product grid for content accuracy
 */
export default function ContentAccuracyProductGrid() {
  const [page, setPage] = useState(1);

  // Get SKUs sorted by retail sales so we can use it as a condition for
  // fetching the content score
  const {
    isLoading: skusLoading,
    skuIndexMap,
    slicedSkus
  } = useRetailSalesSortedSkus({
    pageNumber: page,
    aggregatePages: true
  });

  return (
    <ProductListContainer
      loading={skusLoading}
      headColumnDefinition={{
        headerName: 'Products',
        valueFormatter: (_, row: { product: ProductEntity }) => (
          <div style={{ width: '300px' }}>
            <ProductCell
              key={row.product.stacklineSku}
              stacklineSku={row.product.stacklineSku}
              title={row.product.title}
            />
          </div>
        )
      }}
      useTableDataProps={{
        useGenericAdvancedSearchArgs: {
          shouldPerformFetch: slicedSkus.length > 0 && !skusLoading
        },
        buildRequest: (builder) => {
          return builder.addConditionTermFilter('stacklineSku', 'should', slicedSkus);
        },
        pageNumber: 1
      }}
      entityTableHeaderProps={{
        title: 'Content Accuracy by Product'
      }}
      indexName={BEACON_INDEX_NAMES.NEW_CONTENT_METRICS}
      fields={[
        {
          name: ContentAccuracyFieldName.TitleAccuracy,
          displayName: CONTENT_TABLE_HEADER_DISPLAY_NAMES.TITLE_ACCURACY
        },
        {
          name: ContentAccuracyFieldName.BulletsAccuracy,
          displayName: CONTENT_TABLE_HEADER_DISPLAY_NAMES.BULLET_ACCURACY
        },
        {
          name: ContentAccuracyFieldName.ImageUrlsAccuracy,
          displayName: CONTENT_TABLE_HEADER_DISPLAY_NAMES.IMAGE_ACCURACY
        },
        {
          name: ContentAccuracyFieldName.VideoUrlsAccuracy,
          displayName: CONTENT_TABLE_HEADER_DISPLAY_NAMES.VIDEO_ACCURACY
        }
      ]}
      sortFieldName={ContentAccuracyFieldName.TitleAccuracy}
      showGrid={false}
      postProcessData={(data: { product: ProductEntity }[]) => {
        const res = [...data].sort((a, b) => {
          const aIndex = skuIndexMap[a.product.stacklineSku.toLowerCase()];
          const bIndex = skuIndexMap[b.product.stacklineSku.toLowerCase()];
          return aIndex - bIndex;
        });
        return res;
      }}
      onChangePage={(args) => {
        setPage(args.chunkedPage);
      }}
    />
  );
}
